import { Component } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzResultModule } from 'ng-zorro-antd/result';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [NzButtonModule, NzResultModule],
  template: `
    <nz-result
      nzStatus="404"
      nzTitle="404"
      nzSubTitle="Sorry, the page you visited does not exist."
    >
      <div nz-result-extra>
        <button nz-button nzType="primary" (click)="goToHome()">Back Home</button>
      </div>
    </nz-result>
  `,
})
export class NotFoundComponent {
  constructor(private router: Router) {}

  goToHome(): void {
    this.router.navigate(['']);
  }
}
